import { useEffect, useRef } from "react";

// import { CgArrowsHAlt } from "react-icons/cg";
// import { CgArrowsH } from "react-icons/cg";
// import { RiDragMoveFill } from "react-icons/ri";
import { RiDragMoveLine } from "react-icons/ri";
import { MdEmail } from "react-icons/md";

let cursorW = 25;
let cursorH = 25;

const cursorPosSet = (cursor, x, y) => {
  let posX =  x - cursorW / 2;
  let posY = y - cursorH / 2
  cursor.style.left = posX + 'px';
  cursor.style.top =  posY + 'px';
  document.documentElement.style.setProperty('--mouse-x', posX);
  document.documentElement.style.setProperty('--mouse-y', posY);
}

const Cursor = ({cursorOn}) => {
  const cursorRef = useRef(null);

  useEffect(() => {
    // console.log('Cursor: useEffect: []:');

    let mouseMoveScheduled = null;
    const mouseMoveHandler = (e) => {
      if(!mouseMoveScheduled) {
        setTimeout(() => {
          // console.log('Cursor: mouseMoveHandler called');
          cursorPosSet(cursorRef.current, e.clientX, e.clientY);
          mouseMoveScheduled = null;
        }, 50)
      }
      mouseMoveScheduled = e;
    }
    document.addEventListener('mousemove', mouseMoveHandler);

    let mouseMoveEndTimeout;
    const mouseMoveEndHandler = (e) => {
      clearTimeout(mouseMoveEndTimeout);
      mouseMoveEndTimeout = setTimeout(() => {
        // console.log('Cursor: mouseMoveEndHandler called');
        cursorPosSet(cursorRef.current, e.clientX, e.clientY);
      }, 100);
    }
    document.addEventListener('mousemove', mouseMoveEndHandler);

    return () => {
      // console.log('Cursor: useEffect: []: cleanup');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mousemove', mouseMoveEndHandler);
    }
  }, []);

  return (
    <div className={`part cursor ${cursorOn ? 'show' : 'hide'}`} ref={cursorRef} >

      <div className="cursor__icon drag">
        <span className='icon-container'><RiDragMoveLine /></span>
      </div>
      <div className="cursor__letters drag">
        <div className="letter">D<div className="letter__bottom">D</div></div>
        <div className="letter">R<div className="letter__bottom">R</div></div>
        <div className="letter">A<div className="letter__bottom">A</div></div>
        <div className="letter">G<div className="letter__bottom">G</div></div>
      </div>

      <div className="cursor__icon contact">
        <span className='icon-container'><MdEmail /></span>
      </div>
      <div className="cursor__letters contact">
        <div className="letter">C<div className="letter__bottom">C</div></div>
        <div className="letter">O<div className="letter__bottom">O</div></div>
        <div className="letter">N<div className="letter__bottom">N</div></div>
        <div className="letter">T<div className="letter__bottom">T</div></div>
        <div className="letter">A<div className="letter__bottom">A</div></div>
        <div className="letter">C<div className="letter__bottom">C</div></div>
        <div className="letter">T<div className="letter__bottom">T</div></div>
      </div>
    </div>
  )
}

export default Cursor;